'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by zfc on 2016/10/26.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _reduxForm = require('redux-form');

var _GoeasyDatePicker = require('../GoeasyDatePicker/GoeasyDatePicker');

var _GoeasyDatePicker2 = _interopRequireDefault(_GoeasyDatePicker);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceOrderConfirmComponent = (_dec = (0, _reduxForm.reduxForm)({
  form: 'serviceOrderAcceptanceForm',
  fields: ['acceptanceDate', 'acceptanceState']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ServiceOrderConfirmComponent, _Component);

  function ServiceOrderConfirmComponent() {
    (0, _classCallCheck3.default)(this, ServiceOrderConfirmComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ServiceOrderConfirmComponent).call(this));

    _moment2.default.locale('zh-cn');
    _this.state = {
      date: (0, _moment2.default)()
    };
    return _this;
  }

  (0, _createClass3.default)(ServiceOrderConfirmComponent, [{
    key: 'acceptanceDateChange',
    value: function acceptanceDateChange(value) {
      var acceptanceDate = this.props.fields.acceptanceDate;
      // console.log(value);
      // console.log(value.format('YYYY/MM/DD'));

      this.setState({ date: value });
      acceptanceDate.onChange(value.format('YYYY/MM/DD'));
    }
  }, {
    key: 'acceptanceStateInit',
    value: function acceptanceStateInit(value) {
      var acceptanceState = this.props.fields.acceptanceState;

      acceptanceState.onChange(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var acceptanceState = _props.fields.acceptanceState;
      var serviceOrderAcceptanceData = _props.serviceOrderAcceptanceData;
      var handleSubmit = _props.handleSubmit;
      // acceptanceDate

      var date = this.state.date;

      var styles = require('./ServiceOrderAcceptanceComponent.scss');
      _moment2.default.locale('zh-cn');
      return _react2.default.createElement(
        'div',
        { className: styles.serviceConfirmComponent },
        _react2.default.createElement(
          'div',
          { className: styles.xiodin },
          _react2.default.createElement(
            'span',
            null,
            '订单编号：'
          ),
          _react2.default.createElement(
            'span',
            { style: { width: 230 } },
            serviceOrderAcceptanceData.id
          ),
          _react2.default.createElement(
            'div',
            { className: styles.orderStatus },
            '状态:',
            serviceOrderAcceptanceData.orderStatus
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 8, float: 'right', border: 'none' },
              className: styles.xiodin },
            serviceOrderAcceptanceData.ordetTime
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            'div',
            { className: styles.newPage },
            _react2.default.createElement(
              'div',
              { className: styles.pageTopTitle },
              _react2.default.createElement(
                'span',
                null,
                '购买服务'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.box },
              _react2.default.createElement('img', (0, _defineProperty3.default)({ src: '', className: styles.boxImg }, 'src', serviceOrderAcceptanceData.img)),
              _react2.default.createElement(
                'div',
                { className: styles.serviceContent },
                _react2.default.createElement(
                  'div',
                  { className: styles.tit },
                  serviceOrderAcceptanceData.name
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.text },
                  _react2.default.createElement(
                    'div',
                    { className: styles.textTil },
                    '服务商: '
                  ),
                  serviceOrderAcceptanceData.shop
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.text },
                  _react2.default.createElement(
                    'div',
                    { className: styles.textTil },
                    '联系人: '
                  ),
                  serviceOrderAcceptanceData.contactPerson
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.text },
                  _react2.default.createElement(
                    'div',
                    { className: styles.textTil },
                    '联系方式: '
                  ),
                  serviceOrderAcceptanceData.contactWay
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.text },
                  _react2.default.createElement(
                    'div',
                    { className: styles.textTil },
                    '服务价格: '
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: { color: '#ff0000' } },
                    '¥'
                  ),
                  _react2.default.createElement(
                    'span',
                    {
                      style: { color: '#ff0000' } },
                    serviceOrderAcceptanceData.price
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.text },
                  _react2.default.createElement(
                    'div',
                    { className: styles.textTil },
                    '交付时间: '
                  ),
                  serviceOrderAcceptanceData.deliveryTime
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.text },
                  _react2.default.createElement(
                    'div',
                    { className: styles.textTil },
                    '服务承诺: '
                  ),
                  _react2.default.createElement('img', { className: styles.chengnuoimg }),
                  _react2.default.createElement('img', { className: styles.chengnuoimg })
                )
              )
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'div',
              { style: { marginTop: 10, marginBottom: 10, fontSize: '16px', fontFamily: 'Microsoft YaHei' } },
              '服务内容'
            ),
            _react2.default.createElement(
              'p',
              { className: styles.fuwu },
              serviceOrderAcceptanceData.content
            ),
            serviceOrderAcceptanceData.orderStatus === '待验收' ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: styles.pageTopTitle },
                _react2.default.createElement(
                  'span',
                  null,
                  '验收信息'
                )
              ),
              _react2.default.createElement(
                'h3',
                { className: styles.newPageh3 },
                '交付日期'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.dateDiv },
                _react2.default.createElement(_GoeasyDatePicker2.default, { id: 'acceptanceday', phrases: { closeDatePicker: '关闭' }, placeholder: '验收日期',
                  withPortal: true,
                  displayFormat: 'YYYY/MM/DD', initialVisibleMonth: function initialVisibleMonth() {
                    return date;
                  },
                  isOutsideRange: function isOutsideRange() {
                    return false;
                  },
                  dateChange: this.acceptanceDateChange.bind(this), date: date,
                  monthFormat: 'YYYY[年]MMMM' })
              ),
              _react2.default.createElement('div', { className: 'clear' }),
              _react2.default.createElement(
                'h3',
                { className: styles.newPageh3 },
                '验收说明'
              ),
              _react2.default.createElement(_GoeasyInputField2.default, { goeasyStyle: { width: '90%', marginTop: 20 },
                afterInit: this.acceptanceStateInit.bind(this),
                inputType: 'textarea',
                inputStyle: { float: 'left', marginLeft: 50, width: 650 },
                inputPlaceholder: '',
                formProps: acceptanceState })
            ) : ''
          ),
          _react2.default.createElement('div', { className: styles.link }),
          _react2.default.createElement(
            'div',
            { className: styles.tip },
            _react2.default.createElement(
              'span',
              { className: styles.span1 },
              '保'
            ),
            ' 交易服务由艺品网官方提供交易有保障'
          ),
          serviceOrderAcceptanceData.orderStatus === '待验收' ? _react2.default.createElement(
            'div',
            { className: styles.btn, onClick: handleSubmit },
            '服务验收'
          ) : _react2.default.createElement(
            _reactRouter.Link,
            { className: styles.btn, to: '/serviceorderlist' },
            '返回'
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ServiceOrderConfirmComponent;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func,
  serviceOrderAcceptanceData: _react.PropTypes.object
}, _temp)) || _class);
exports.default = ServiceOrderConfirmComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServiceOrderAcceptanceComponent/ServiceOrderAcceptanceComponent.js
 ** module id = 1418
 ** module chunks = 0
 **/